// POST /rays · GET /rays/compliments
import { z } from 'zod'
import { linkTypeSchema } from '../enums.js'
import { idSchema, isoDateTimeSchema } from './common.js'

export const rayDtoSchema = z.object({
  id: idSchema,
  link_id: idSchema,
  text: z.string().max(40).nullable(),
  compliment_id: idSchema.nullable(),
  created_at: isoDateTimeSchema,
})
export type RayDto = z.infer<typeof rayDtoSchema>

// POST /rays — единственный жест поддержки. Комплимент — это текст лучика, не своя сущность.
// И text, и compliment_id опциональны — «можно пропустить» (лучик без слов тоже долетает).
export const createRayRequestSchema = z.object({
  link_id: idSchema,
  text: z.string().max(40).optional(),
  compliment_id: idSchema.optional(),
})
export type CreateRayRequest = z.infer<typeof createRayRequestSchema>
export const createRayResponseSchema = rayDtoSchema
export type CreateRayResponse = z.infer<typeof createRayResponseSchema>

export const complimentDtoSchema = z.object({
  id: idSchema,
  text: z.string(),
})
export type ComplimentDto = z.infer<typeof complimentDtoSchema>

// GET /rays/compliments?link_type — курируемый пул, ротация по типу связи.
export const listComplimentsQuerySchema = z.object({
  link_type: linkTypeSchema,
})
export type ListComplimentsQuery = z.infer<typeof listComplimentsQuerySchema>
export const listComplimentsResponseSchema = z.object({
  items: z.array(complimentDtoSchema),
})
export type ListComplimentsResponse = z.infer<typeof listComplimentsResponseSchema>
